import { DOCUMENT_TITLE_BRAND } from '../lib/use-document-title.js';

/** The wordmark in the header, until the owner names the product. Not test-pinned. */
export const BRAND_NAME = DOCUMENT_TITLE_BRAND;
